import React from "react";
import { Card, Text, TextLink } from "@origin-digital/ods-core";
import styled from "styled-components";

const StyledCard = styled(Card)`
  display: grid;
  gap: 8px;
`;
type Props = {
  relatedItems: Array<{
    label: string;
    query: string;
    href: string;
  }>;
};
export const RelatedSearches = ({ relatedItems }: Props) => {
  return (
    <StyledCard
      data-id="suggested-searches"
      outline
      paddingYSpecific="large"
      paddingXSpecific="medium"
    >
      <Text>Still can't find what you're looking for?</Text>
      {relatedItems.map((item) => (
        <Text key={item.query} tone="neutralDark">
          <TextLink href={`?term=${encodeURIComponent(item.query)}`}>
            {item.query}
          </TextLink>
        </Text>
      ))}
    </StyledCard>
  );
};
